import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { User } from '../../master-editar-perfil-acesso.models';
import { MasterEditarPerfilAcessoService } from '../../master-editar-perfil-acesso.service';

@Component({
  selector: 'app-master-editar-perfil-duplicacao',
  templateUrl: './master-editar-perfil-duplicacao.component.html',
  styleUrls: ['./master-editar-perfil-duplicacao.component.scss']
})
export class MasterEditarPerfilDuplicacaoComponent implements OnInit {

  users;
  permissionGroups;

  constructor(public dialogRef: MatDialogRef<MasterEditarPerfilDuplicacaoComponent>,
    private masterEditarPerfilAcesso: MasterEditarPerfilAcessoService) { }

  ngOnInit() {
  }

  editUsers(users: User[]) {
    this.masterEditarPerfilAcesso.editUsers(users)
      .subscribe(response => {
        this.dialogRef.close(true);
      });
  }

  editPermissionGroups(permissions) {
    this.masterEditarPerfilAcesso.editPermissionGroups(permissions)
      .subscribe(response => {
        this.editUsers(this.users);
        //this.dialogRef.close(true);
      });
  }

  savePermissions() {
    this.editPermissionGroups(this.permissionGroups);
   // this.editUsers(this.users);
  }

}
